"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fill: ", "\n"])), function (props) {
  return props.theme.button.background;
});
var HearIcon = function HearIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M8.625 0C10.489 0 12 1.51104 12 3.375C12 3.45488 11.9972 3.53412 11.9918 3.61262C11.9972 3.65756 12 3.70348 12 3.75C12 5.79159 10 8.54159 6 12C2 8.86224 0 6.11224 0 3.75C0 3.69889 0.00249713 3.64861 0.00741863 3.59917C0.00248423 3.52556 0 3.45057 0 3.375C0 1.51104 1.51104 0 3.375 0C4.43518 0 5.38119 0.488836 5.99993 1.25341C6.61881 0.488836 7.56482 0 8.625 0Z",
    fillRule: "evenodd"
  }));
};
var _default = exports.default = (0, _react.memo)(HearIcon);